import { useState } from 'react';
import { RiCloseLargeFill } from 'react-icons/ri';
import { CiMenuBurger } from 'react-icons/ci';
import { Link } from 'react-router-dom';
import ScrollToTop from './scroll';

const Header = () => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const toggleMenu = () => {
        setOpen(!open);
        if (index === 50) {
            setIndex(0);
        }
        else {
            setIndex(50);
        }
        console.log(index)
    };

    const resetMenu = () => {
        setOpen(false);
        setIndex(0);
    }

    return (
        <header className="lg:p-3 lg:flex lg:row lg:content-center lg:static lg:z-[-1] w-full lg:w-auto fixed top-0 left-0" style={{ zIndex: open ? 50 : 0 }}>
            <ScrollToTop />
            <h1 className="bg-white text-center lg:pl-8 font-semibold text-[1em] leading-7 p-4 lg:p-0 lg:m-4 lg:ml-4 lg:mt-4 uppercase">
                <Link className="lg:hover:animate-zoom lg:hover:opacity-50" to="/">
                    <span className="text-navy tracking-spaced">Al</span>
                    <span className="text-ocean tracking-spaced">kor</span>
                </Link>
            </h1>
            {open ? (
                <RiCloseLargeFill size={20} onClick={toggleMenu} className="z-20 fixed mt-6 ml-4 top-0 left-0 lg:hidden" />
            ) : (
                <CiMenuBurger size={20} onClick={toggleMenu} className="absolute mt-6 ml-4 top-0 left-0 lg:hidden" />
            )}

            <nav
                className={`${open ? 'translate-x-0' : '-translate-x-full'
                    } lg:translate-x-0 bg-white ml-0 pt-[2em] lg:pt-auto w-screen h-screen lg:w-auto lg:h-auto lg:static text-center lg:pl-6 lg:pr-16 text-[0.8em] uppercase lg:p-4 lg:flex lg:row content-start lg:content-center lg:ml-auto transition-transform duration-300 ease-in-out`}
                style={{ zIndex: open ? 50 : 0 }}>
                <Link to="/" onClick={resetMenu} className="lg:hidden lg:block hover:text-ocean ml-24 mr-2">
                    <p>Home</p>
                </Link>
                <Link to="/partners" onClick={resetMenu} className="lg:block hover:text-ocean ml-24 mr-2">
                    <p>Partners</p>
                </Link>
                <Link to="/about" onClick={resetMenu} className="lg:block hover:text-ocean ml-24 mr-2">
                    <p>About</p>
                </Link>
                <Link to="/contact" onClick={resetMenu} className="lg:block hover:text-ocean ml-24 mr-2">
                    <p>Contact</p>
                </Link>
            </nav>
        </header>
    );
};

export default Header;
